import { useEffect, useState } from 'react';
import ventasConfigService from '../services/ventasConfigService';

export interface ClientePredeterminadoSucursalState {
  loading: boolean;
  nroCliente: number | null;
  nombre: string | null;
  configurado: boolean;
}

const INITIAL: ClientePredeterminadoSucursalState = {
  loading: true,
  nroCliente: null,
  nombre: null,
  configurado: false,
};

/**
 * Cliente predeterminado de la sucursal
 * (GET /api/VentasConfig/cliente-predeterminado?nroSuc=).
 */
export function useClientePredeterminadoSucursal(nroSuc: number): ClientePredeterminadoSucursalState {
  const [state, setState] = useState<ClientePredeterminadoSucursalState>(INITIAL);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (!Number.isFinite(nroSuc) || nroSuc <= 0) {
        if (!cancelled) {
          setState({ loading: false, nroCliente: null, nombre: null, configurado: false });
        }
        return;
      }

      if (!cancelled) setState((prev) => ({ ...prev, loading: true }));

      try {
        const dto = await ventasConfigService.getClientePredeterminado(nroSuc);
        if (cancelled) return;

        const nro = dto.nroCliente != null && dto.nroCliente > 0 ? dto.nroCliente : null;
        setState({
          loading: false,
          nroCliente: nro,
          nombre: dto.nombre ?? null,
          configurado: Boolean(dto.configurado && nro != null),
        });
      } catch {
        if (!cancelled) {
          setState({ loading: false, nroCliente: null, nombre: null, configurado: false });
        }
      }
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, [nroSuc]);

  return state;
}
